<template>
	<!-- Closed trade -->
	<div class="trading-item trading-card card" v-if="trade.status === 'closed'">
		<div class="trading-card__row">
			<i class="trading-card__icon" :class="{
				 'trading-card__icon--green' : trade.profit > 0,
				 'trading-card__icon--bg-green' : trade.profit > 0,
				 'trading-card__icon--red' : trade.profit < 0,
				 'trading-card__icon--bg-red' : trade.profit < 0
			}">
				<Icon :name="trade.profit > 0 ? 'check' : 'close'" />
			</i>
			<span class="trading-card__title">Prediction was {{ trade.profit > 0 ? 'successful' : 'unsuccessful' }}!</span>
		</div>
		<div class="trading-card__row">
			<i class="trading-card__icon" :class="{
				'trading-card__icon--red' : trade.course_opened! > trade.course_closed!,
				'trading-card__icon--green' : trade.course_opened! < trade.course_closed!,
			}">
				<Icon :name="trade.course_opened! > trade.course_closed! ? 'arrow-bottom-right' : 'arrow-top-right'" />
			</i>
			<span class="trading-card__title">Price is {{ trade.course_opened! > trade.course_closed! ? 'DOWN' : 'UP' }}</span>
			<span class="trading-card__value" :data-currency="`USDT/${trade.currency.toUpperCase()}`">to {{trade.course_closed!}}</span>
		</div>
		<div class="trading-card__row">
			<i class="trading-card__icon trading-card__icon--green">
				<Icon name="long" />
			</i>
			<span class="trading-card__title">Profit of trade is:</span>
			<span class="trading-card__value" :data-currency="`USDT/${trade.currency.toUpperCase()}`">{{ (trade.profit * 100).toFixed(2) }} %</span>
		</div>
	</div>
	<!-- Closed trade end -->

	<!-- Opened trade -->
	<div class="trading-card trading-current card" v-else-if="trade.status === 'opened'">
		<div class="trading-card__row">
			<i class="trading-card__icon trading-card__icon--black trading-card__icon--bg-orange">
				<Icon name="flag" />
			</i>
			<span class="trading-card__title trading-current__title">Opening new trade...</span>
		</div>
		<div class="trading-card__row">
			<i class="trading-card__icon"></i>
			<span class="trading-card__title">Actual price:</span>
			<span class="trading-card__value" :data-currency="`USDT/${trade.currency.toUpperCase()}`">{{ trade.course_opened! }}</span>
		</div>
	</div>
	<!-- Opened trade end -->

</template>
<script lang="ts" setup>

import Icon from "@/components/Icon/Icon.vue";
import TradeEntity from "@/entities/TradeEntity";

let {trade} = defineProps<{
	trade : TradeEntity
}>();


</script>